import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import GeneralRoutes from './routes/GeneralRoutes';
import { userDataSelector, tokenSelector } from './store/selectors/authSelector';
import { GtmInjector } from './components/GtmInjector';

// Espaces authentifiés en chunks séparés : /login et /register ne chargent
// plus recharts, flatpickr ni les containers admin/member.
const UserRoutes = lazy(() => import('./routes/UserRoutes'));
const AdminRoutes = lazy(() => import('./routes/AdminRoutes'));

const RouteFallback = () => (
  <div className="flex h-screen items-center justify-center bg-background" role="status" aria-label="Loading">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary motion-reduce:animate-none" />
  </div>
);

const App = () => {
  const token = useSelector(tokenSelector);
  const userData = useSelector(userDataSelector);
  const isUserSuperAdmin = userData && userData.role === 'SuperAdmin';

  const Inner = (
    <BrowserRouter>
      <GtmInjector />
      {
        token
          ? (
            <Suspense fallback={<RouteFallback />}>
              {isUserSuperAdmin
                ? <AdminRoutes/>
                : <UserRoutes roles={userData?.role}/>}
            </Suspense>
          ) : <GeneralRoutes/>
      }
    </BrowserRouter>
  );
  return import.meta.env.DEV
    ? <ErrorBoundary>{Inner}</ErrorBoundary>
    : Inner;
};

export default App;
